class ExtendableError extends Error {
  constructor(message = '') {
    super(message)

    Object.defineProperty(this, 'message', {
      configurable: true,
      enumerable : false,
      value : message,
      writable : true,
    })

    Object.defineProperty(this, 'name', {
      configurable: true,
      enumerable : false,
      value : this.constructor.name,
      writable : true,
    })
  }
}

export { ExtendableError }